/** @format */

import { useEffect } from 'react'
import { asyncGetProductList } from 'src/store/globalDataSlice'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, AppDispatch } from 'src/store'
import moment from 'moment'

// type useGlobalData<TYPE, T> = (dataType: TYPE) => T

const useGlobalData = dataType => {
  const globalData = useSelector((state: RootState) => state.globalData)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    const data = globalData[dataType]
    const { list, startTime } = data
    const expired = startTime ? moment().diff(moment(startTime), 'days') > 0 : true
    if (!list?.length || expired) {
      dispatch(asyncGetProductList(dataType))
    }
  }, [])
  return globalData[dataType].list
}

export default useGlobalData
